/* The Mat Group - orientation diagram: "Click to expand" (matches the product-gallery zoom) + instant
   (preloaded) portrait/landscape switching with a soft crossfade. Shared by all 3 configurators
   (logo-options, mat-configurator, custom-size-options) WITHOUT touching their logic.
   It preloads both orientation images, wraps the diagram <img> in a clickable figure with a corner
   "Click to expand" badge, opens a cinematic full-screen lightbox (scale + fade), and crossfades the
   inline diagram whenever its orientation actually changes. Self-contained, idempotent, fault-tolerant. */
(function(){
  if(window.__TMG_DIAG_ZOOM__) return; window.__TMG_DIAG_ZOOM__ = 1;

  var SEL = '.lw-diagram,.mc-sizediagram,.cso-diagram';
  var MAG = '<svg class="tmg-diag-mag" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="7" cy="7" r="5" fill="none" stroke="currentColor" stroke-width="1.6"/><line x1="10.7" y1="10.7" x2="14.5" y2="14.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  /* ---- preload both orientation images so every switch / expand is instant (no load wait) ---- */
  function urlsFrom(o){ if(!o) return []; return [o.diagramLandscape, o.diagramPortrait, o.diagram].filter(Boolean); }
  var urls = urlsFrom(window.__LGO_PRODUCT__).concat(urlsFrom(window.__MAT_PRODUCT__)).concat(urlsFrom(window.__CSO_PRODUCT__));
  urls = urls.filter(function(u,i){ return urls.indexOf(u)===i; });
  var CACHE = {};
  function preload(u){ if(!u||CACHE[u]) return; var im=new Image(); im.decoding='async'; im.src=u; CACHE[u]=im; }
  urls.forEach(preload);

  /* ---- styles (injected once, no theme CSS edits) ---- */
  var st=document.createElement('style'); st.id='tmg-diag-zoom-css';
  st.textContent =
    '.tmg-diag-fig{position:relative;display:inline-block;max-width:100%;margin:0 0 12px;cursor:zoom-in;line-height:0;vertical-align:top;outline:none}'+
    '.tmg-diag-fig>img{display:block;margin:0!important;max-width:100%;transition:opacity .25s ease}'+
    '.tmg-diag-badge{position:absolute;right:8px;bottom:8px;display:inline-flex;align-items:center;gap:5px;background:rgba(255,255,255,.92);border:1px solid rgba(0,0,0,.14);border-radius:6px;padding:4px 8px;font-size:11px;line-height:1;font-weight:500;color:#33373b;box-shadow:0 1px 3px rgba(0,0,0,.14);pointer-events:none;white-space:nowrap;transition:background .15s ease,box-shadow .15s ease}'+
    '.tmg-diag-mag{flex:0 0 auto}'+
    '.tmg-diag-fig:hover .tmg-diag-badge{background:#fff;box-shadow:0 2px 7px rgba(0,0,0,.2)}'+
    '.tmg-diag-fig:focus-visible{outline:2px solid #0a66c2;outline-offset:3px;border-radius:6px}'+
    '.tmg-diag-lb{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:4vmin;background:rgba(12,14,18,.86);opacity:0;transition:opacity .3s ease;-webkit-tap-highlight-color:transparent}'+
    '.tmg-diag-lb.on{opacity:1}'+
    '.tmg-diag-lb .tmg-diag-stage{position:relative;display:flex;align-items:center;justify-content:center;max-width:94vw;max-height:92vh}'+
    '.tmg-diag-lb img{max-width:94vw;max-height:92vh;width:auto;height:auto;object-fit:contain;background:#fff;border-radius:12px;box-shadow:0 24px 80px rgba(0,0,0,.55);transform:scale(.9);opacity:0;transition:transform .38s cubic-bezier(.16,1,.3,1),opacity .3s ease;cursor:zoom-out}'+
    '.tmg-diag-lb.on img{transform:scale(1);opacity:1}'+
    '.tmg-diag-x{position:fixed;top:16px;right:22px;font-size:34px;line-height:1;color:#fff;background:none;border:0;cursor:pointer;opacity:.85;padding:6px 10px;z-index:1}'+
    '.tmg-diag-x:hover,.tmg-diag-x:focus-visible{opacity:1;outline:none}';
  (document.head||document.documentElement).appendChild(st);

  /* ---- cinematic lightbox (lazy) ---- */
  var lb=null, lbImg=null, lastFocus=null;
  function buildLb(){
    lb=document.createElement('div'); lb.className='tmg-diag-lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true'); lb.setAttribute('aria-label','Enlarged orientation diagram');
    lb.innerHTML='<button type="button" class="tmg-diag-x" aria-label="Close">&times;</button><div class="tmg-diag-stage"><img alt="Mat orientation diagram, enlarged"></div>';
    lbImg=lb.querySelector('img');
    document.body.appendChild(lb);
    lb.addEventListener('click',function(e){ if(e.target===lb || e.target===lbImg || e.target.closest('.tmg-diag-x')) close(); });
    lb.addEventListener('keydown',function(e){ if(e.key==='Tab'){ e.preventDefault(); var x=lb.querySelector('.tmg-diag-x'); if(x) x.focus(); } });
  }
  function open(src){
    if(!src) return; if(!lb) buildLb();
    lastFocus=document.activeElement;          // remember trigger so we can restore focus on close
    lbImg.src=src;                             // preloaded -> shows instantly
    document.documentElement.style.overflow='hidden';
    lb.style.display='flex';
    void lb.offsetWidth;                       // force reflow so the enter transition runs from the base state
    lb.classList.add('on');
    var x=lb.querySelector('.tmg-diag-x'); if(x){ try{ x.focus(); }catch(e){} }
  }
  function close(){ if(!lb) return; lb.classList.remove('on'); document.documentElement.style.overflow='';
    if(lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} } lastFocus=null;
    setTimeout(function(){ if(lb && !lb.classList.contains('on')) lb.style.display='none'; }, 400); }
  function openFor(img){ if(!img) return; var s=img.currentSrc||img.getAttribute('src')||img.src; if(s) open(s); }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && lb && lb.classList.contains('on')) close(); });

  /* document-level fallback: only fires if the figure's own handler somehow didn't (e.g. unwrapped img) */
  document.addEventListener('click',function(e){
    if(e.target.closest('.tmg-diag-fig')) return;   // handled by the figure's own listener
    var img=e.target.closest(SEL); if(img) openFor(img);
  });

  /* ---- wrap each diagram in a clickable figure with the "Click to expand" badge ---- */
  function ensureFig(img){
    var p=img.parentNode;
    if(p && p.classList && p.classList.contains('tmg-diag-fig')) return; // already wrapped
    if(!p) return;
    var fig=document.createElement('span'); fig.className='tmg-diag-fig'; fig.__tmgImg=img;
    fig.setAttribute('role','button'); fig.setAttribute('tabindex','0'); fig.setAttribute('aria-label','Click to expand the orientation diagram');
    p.insertBefore(fig, img); fig.appendChild(img);
    var badge=document.createElement('span'); badge.className='tmg-diag-badge'; badge.innerHTML=MAG+'<span>Click to expand</span>';
    fig.appendChild(badge);
    fig.addEventListener('click', function(){ openFor(img); });
    fig.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){ e.preventDefault(); openFor(img); } });
  }

  /* ---- crossfade the inline diagram only when its orientation actually changes ---- */
  function fade(img){ img.style.opacity='0'; requestAnimationFrame(function(){ requestAnimationFrame(function(){ img.style.opacity='1'; }); }); }
  function onImg(img){
    ensureFig(img);
    var s=img.currentSrc||img.getAttribute('src')||img.src;
    if(!img.__tmgInit){ img.__tmgInit=1; img.__tmgSrc=s; if(settled) fade(img); return; }
    if(s!==img.__tmgSrc){ img.__tmgSrc=s; fade(img); }
  }
  function scanIn(node){
    if(!node || node.nodeType!==1) return;
    if(node.matches && node.matches(SEL)) onImg(node);
    if(node.querySelectorAll){ Array.prototype.forEach.call(node.querySelectorAll(SEL), onImg); }
  }

  /* initial pass: wrap existing diagrams (no fade-in flash on load) */
  var settled=false;
  Array.prototype.forEach.call(document.querySelectorAll(SEL), onImg);
  settled=true;  // anything appearing/changing from now is user-driven -> crossfade

  /* observe the configurator roots only (scoped + cheap) */
  var roots=['logo-options','mat-configurator','custom-size-options'].map(function(id){return document.getElementById(id);}).filter(Boolean);
  if(roots.length && window.MutationObserver){
    var mo=new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){ var m=muts[i];
        if(m.type==='attributes' && m.target && m.target.matches && m.target.matches(SEL)) onImg(m.target);
        else if(m.type==='childList'){ Array.prototype.forEach.call(m.addedNodes,scanIn); }
      }
    });
    roots.forEach(function(r){ mo.observe(r,{subtree:true,childList:true,attributes:true,attributeFilter:['src']}); });
  }
})();
